import Vue from 'vue'

Vue.mixin({
  data() {
    return {
      get isMobile() {
        if (
          /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          return true
        } else {
          return false
        }
      }
    }
  },

  methods: {
    getDateToday() {
      let date = new Date()
      return new Date(date.getFullYear(), date.getMonth(), date.getDate())
    },

    parseDate(date) {
      let d = new Date(date)
      let day = `0${d.getDate()}`.slice(-2)
      let month = `0${d.getMonth() + 1}`.slice(-2)
      let year = d
        .getFullYear()
        .toString()
        .substr(-2)

      return `${year}-${month}-${day}`
    },

    scrollToTop() {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }
  }
})
